import React from 'react'
import { Link } from 'react-router-dom';
import { checkPermission } from '../../helpers/commonFunctions';


const BrandConfigurationReportTab = ({ tab: Tab }) => {

    return (
        <ul className='d-flex setting w-100 mb-0 p-0'>
            {checkPermission('store_brand_sales_report', 'view') && (
                <li className={Tab === 'sales' ? 'active' : ''}>
                    <Link to={`/company/brand-report/sales_report/list/${1}`} className="btn">
                        Sales Report
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_payment_report', 'view') && (
                <li className={Tab === 'payment' ? 'active' : ''}>
                    <Link to={`/company/brand-report/payment/list/${1}`} className="btn">
                        Payment Report
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_item_cost_calculation_report', 'view') && (
                <li className={Tab === 'cost' ? 'active' : ''}>
                    <Link to={`/company/brand-report/item_cost/list/${1}`} className="btn">
                        Item Cost Calculation
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_stock_movement_report', 'view') && (
                <li className={Tab === 'stock_movement' ? 'active' : ''}>
                    <Link to={`/company/brand-report/stock_movement/list/${1}`} className="btn">
                        Stock Movement Report
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_erp_reports', 'view') && (
                <li className={Tab === 'erp' ? 'active' : ''}>
                    <Link to={`/company/brand-report/erp_sales/list/${1}`} className="btn">
                        ERP Report
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_zatca_report', 'view') && (
                <li className={Tab === 'zatca' ? 'active' : ''}>
                    <Link to={`/company/brand-report/zatca/list/${1}`} className="btn">
                        ZATCA Report
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_zatca_report', 'view') && (
                <li className={Tab === 'zatca_new' ? 'active' : ''}>
                    <Link to={`/company/brand-report/zatca_new/list/${1}`} className="btn">
                        ZATCA Report New
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_discount_report', 'view') && (
                <li className={Tab === 'discount' ? 'active' : ''}>
                    <Link to={`/company/brand-report/discount/list/${1}`} className="btn">
                        Discount Report
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_refund_report', 'view') && (
                <li className={Tab === 'refund' ? 'active' : ''}>
                    <Link to={`/company/brand-report/refund/list/${1}`} className="btn">
                        Refund Report
                    </Link>
                </li>
            )}
            {checkPermission('store_brand_waste_report', 'view') && (
                <li className={Tab === 'waste' ? 'active' : ''}>
                    <Link to={`/company/brand-report/waste/list/${1}`} className="btn">
                        Waste Report
                    </Link>
                </li>
            )}
        </ul>
    );
}

export default BrandConfigurationReportTab
